//import merge from 'lodash-es/merge'
//import merge from 'deepmerge'

import {FETCH_VIEWPORT_SUCCESS } from './viewportActions'
import {TOGGLE_MENU_VISIBILITY, TOGGLE_INFO_VISIBILITY, TOGGLE_CHART_VISIBILITY} from './uiActions'
import {SET_VIEWPORT_ITEM_LAST_STATE_VISIBILITY, SET_VIEWPORT_ITEM_TRAJECTORY_VISIBILITY,
  SET_VIEWPORT_ITEM_CHART_VISIBILITY, 
  FETCH_VIEWPORT_ITEM_SCHEDULED, SET_VIEWPORT_ITEM_AUTO_REFRESH, SET_COMPARISON_TIME_VISIBILITY}
  from './viewportItemActions'
import {SET_API_URLS, SET_MAP, MAP_STYLE_LOADING, SET_MAP_STYLE} from './uiActions'
import {SET_VIEWPORT_NOTES, SET_VIEWPORT_ITEM_NOTES} from './viewportActions'
import {FETCH_VIEWPORT_ITEM_COMPARISON_SUCCESS} from './viewportItemActions'
import {START_TIMER, SET_TIMER_CONSTANT, SET_TIMER_VISIBILITY, SET_MAP_LAYERS, 
        MAP_FIRST_IDLE_TIME, SET_VIEWPORT_ITEM_ZOOM_TO,
        SET_DISPLAY_TIME, SET_PLAYBACK_STATE } from './uiActions'

const initialState = {
  viewportTimeoutId: null,
  menuVisible: true,
  infoVisible: true,
  chartVisible: true,

  // last state and rajectory are updated the same time
  viewportItemTimeouts: {}, // viewportItemId -> timeout
  viewportItemHwms: {}, // viewportItemId -> last request timestamp high water mark

  itemLastStateVisible: {},
  itemTrajectoryVisible: {},
  itemComparisonTimeVisible: {},
  itemChartVisible: {},
  itemAutoRefresh: {},
  itemUpdateFreqSec: {},

  apiURL: '//movingobject.co/api',
  jsonURL: null, // '//movingobject.co/keknap21/data/',

  viewportNotes: [],
  viewportItemNotes: {},

  viewportItemConfigs: {},
  viewportItemComparisonData: {},
  
  map: null, 
  // the map base style to be displayed
  mapStyle: MAP_DEFAULT_STYLE,
  // indicates if the map style is loading; true when progressing, false when loaded
  mapStyleLoading: false,
  //mapStyleLoaded: 0,

  mapLayerCounter: 0,
  firstIdleTime: null,

  // which viewport item was zoomed
  viewportItemZoomTo: null,

  // for playback: global display timestamp
  // UTC timestamps (milliseconds)
  displayTime: {timeFrom: null, timeTo: null},  
  
  playbackState: 'init', // 'playing',
  //lastStatesBoundingBox: {"minLat": 500, "maxLat": 0, "minLon": 500, "maxLon": 0}
}

const uiReducer = (state = initialState, action) => {
  // console.log("uiReducer: " + action.type)
  // merge({}, state, action.entities.comments.byId)
  var id, newConf, newVisibility 
  switch (action.type) {
    
    case FETCH_VIEWPORT_SUCCESS:
      var confs = {}
      action.response.data.items.map(
        (item, index) => {
          if (JSON.parse(item.config)) {
            confs[item.viewport_item_id] = JSON.parse(item.config)
          }
        }
      )
      //return merge({}, state,
      //             {viewportTimeoutId: action.timeout},
      //             {viewportItemConfigs: confs})
      return {
        ...state,
        viewportTimeoutId: action.timeout,
        viewportItemConfigs: {
          ...state.viewportItemConfigs,
          ...confs
        }
      }
 
    case TOGGLE_MENU_VISIBILITY:
      //return merge( {}, state,
      //  { menuVisible: (! state.menuVisible) } )
      //return merge( state, { menuVisible: (! state.menuVisible) } )
      return {
        ...state,
        menuVisible: (! state.menuVisible)
      }
  
    case TOGGLE_INFO_VISIBILITY:
      return {
        ...state,
        infoVisible: (! state.infoVisible)
      }

    case TOGGLE_CHART_VISIBILITY:
      return {
        ...state,
        chartVisible: (! state.chartVisible)
      }
  
      //return merge( {}, state,
      //  { infoVisible: (! state.infoVisible) } )

    case SET_VIEWPORT_ITEM_LAST_STATE_VISIBILITY:
      id = action.viewportItemId
      if (action.visibility == null ) {
        // toggle visibility
        newVisibility = (! state.itemLastStateVisible[id] )
      }
      else {
        // set visibility, but don't overwrite existing value with default
        if ( (! action.isDefault) || (! (id in state.itemLastStateVisible)) ){
          newVisibility = action.visibility
        }

      }
      newConf = {}
      newConf[id] = newVisibility
      //return merge( {}, state, {itemLastStateVisible: newConf} )
      return {
        ...state, 
        itemLastStateVisible: {
          ...state.itemLastStateVisible, 
          ...newConf
        }
      }

    case SET_VIEWPORT_ITEM_TRAJECTORY_VISIBILITY:
      id = action.viewportItemId
      if (action.visibility == null ) {
        // toggle visibility
        newVisibility = (! state.itemTrajectoryVisible[id] )
      }
      else {
        // set visibility, but don't overwrite existing value with default
        if ( (! action.isDefault) || (! (id in state.itemTrajectoryVisible)) ) {
          newVisibility = action.visibility
        }
        else {
          newVisibility = state.itemTrajectoryVisible[id]
        }
      }
      //console.log("SET_VIEWPORT_ITEM_TRAJECTORY_VISIBILITY newVisibility:", 
      //            action.visibility, state.itemTrajectoryVisible, '-->', newVisibility )
      newConf = {}
      newConf[id] = newVisibility
      //return merge( {}, state, {itemTrajectoryVisible: newConf} )
      return {
        ...state,
        itemTrajectoryVisible: {
          ...state.itemTrajectoryVisible,
          ...newConf
        }
      }

    case SET_VIEWPORT_ITEM_CHART_VISIBILITY:
        id = action.viewportItemId
        if (action.visibility == null ) {
          // toggle visibility
          newVisibility = (! state.itemChartVisible[id] )
        }
        else {
          // set visibility, but don't overwrite existing value with default
          if ( (! action.isDefault) || (! (id in state.itemChartVisible)) ) {
            newVisibility = action.visibility
          }
  
        }
        newConf = {}
        newConf[id] = newVisibility
        //return merge( {}, state, {itemChartVisible: newConf} )
        return {
          ...state, 
          itemChartVisible: {
            ...state.itemChartVisible,
            ...newConf
          }
        }

    case FETCH_VIEWPORT_ITEM_SCHEDULED:
      //var newt = {}
      //newt[action.viewportItemId] = action.timeout
      //var tts = merge(state.viewportItemTimeouts, newt)
      return {
        ...state,
        viewportItemTimeouts: {
          ...state.viewportItemTimeouts,
          [action.viewportItemId]: action.timeout
        },
        viewportItemHwms: {
          ...state.viewportItemHwms,
          [action.viewportItemId]: action.hwm
        }
      }
      //return merge( {}, state, {viewportItemTimeouts: tts} )

    case SET_VIEWPORT_ITEM_AUTO_REFRESH:
      // viewportItemId, autoRefresh, updateFreqSec

      //console.log('SET_VIEWPORT_ITEM_AUTO_REFRESH: ' + action.autoRefresh)
      return {
        ...state,
        itemAutoRefresh: {
          ...state.itemAutoRefresh,
          [action.viewportItemId]: action.autoRefresh
        },
        itemUpdateFreqSec: {
          ...state.itemUpdateFreqSec,
          [action.viewportItemId]: action.updateFreqSec
        }
      }

//    // compute a bounding box of last states for UI:
//    case FETCH_VIEWPORT_ITEM_LAST_STATE_SUCCESS:
//      // viewportItemId, lastStateResponse.data
//      if (! state.itemLastStateVisible[action.viewportItemId]) return state
//
//      var d = action.lastStateResponse.data
//      var s = state.lastStatesBoundingBox
//
//      var minLat = d.latitude < s.minLat ?  d.latitude : s.minLat
//      var maxLat = d.latitude > s.maxLat ?  d.latitude : s.maxLat
//      var minLon = d.longitude < s.minLon ?  d.longitude : s.minLon
//      var maxLon = d.longitude > s.maxLon ?  d.longitude : s.maxLon
//      console.log(minLat, maxLat, minLon, maxLon)
//
//      return {
//        ...state,
//        lastStatesBoundingBox: {
//          "minLat": minLat,
//          "maxLat": maxLat,
//          "minLon": minLon,
//          "maxLon": maxLonviewportItemTimeouts
//        }
//      }

    case SET_API_URLS:
      return {
        ...state,
        apiURL: action.apiURL,
        jsonURL: action.jsonURL
      }

    case SET_VIEWPORT_NOTES:
      return {
        ...state,
        viewportNotes: action.notes
      }

    case SET_VIEWPORT_ITEM_NOTES:
      return {
        ...state,
        viewportItemNotes: action.notes
      }

    case START_TIMER:
      return {
        ...state,
        timerZero: action.zero,
        timerVisibility: action.visibility
      }

    case SET_TIMER_CONSTANT:
      return {
        ...state,
        timerConstant: action.constant,
        timerVisibility: action.visibility
      }

    case SET_TIMER_VISIBILITY:
      return {
        ...state,
        timerVisibility: action.visibility
      }

    case FETCH_VIEWPORT_ITEM_COMPARISON_SUCCESS:
      if (action.data) {
        return {
          ...state,
          viewportItemComparisonData: {
            ...state.viewportItemComparisonData,
            [action.viewportItemId]: action.data
          },
          itemComparisonTimeVisible: {
            ...state.itemComparisonTimeVisible,
            [action.viewportItemId]: true
          }
        }
      }
      else return state

    case SET_COMPARISON_TIME_VISIBILITY:
      var vis = action.visibility
      if (! vis )
        vis = ! state.itemComparisonTimeVisible[action.viewportItemId]

      return {
        ...state,
        itemComparisonTimeVisible: {
          ...state.itemComparisonTimeVisible,
          [action.viewportItemId]: vis
        }
      }
      
    case SET_MAP:
      return {
        ...state,
        map: action.map
      }
    case SET_MAP_LAYERS:
      return {
        ...state,
        mapLayerCounter: action.mapLayerCount + state.mapLayerCounter
      }
    case MAP_FIRST_IDLE_TIME:
      return {
        ...state,
        firstIdleTime: action.firstIdleTime
      }

    case SET_MAP_STYLE:
      return {
        ...state,
        mapStyle: action.mapStyle
      }
  
    case MAP_STYLE_LOADING:
      return {
        ...state,
        mapStyleLoading: action.mapStyleLoading
      }
  
    //case MAP_STYLE_LOADED:
    //  return {
    //    ...state,
    //    mapStyleLoadedCt: state.mapStyleLoadedCt + 1,
    //    mapStyle: action.style
    //  }
    case SET_VIEWPORT_ITEM_ZOOM_TO: 
    return {
      ...state,
      viewportItemZoomTo: action.viewportItemId
    }

    case SET_DISPLAY_TIME:
      return {
        ...state,
        displayTime: {
          timeFrom: action.displayTime.timeFrom, 
          timeTo: action.displayTime.timeTo
        }
      }

    case SET_PLAYBACK_STATE: 
      return {
        ...state,
        playbackState: action.playbackState
      }

    default:
      return state
  }
}



export default uiReducer
